/** @format */
export const DisplayName = {
	YMAL: 'You May Also Like',
	CA: 'More To Consider'
};
